angular
    .module('app')
    .component('contractsList', {
        templateUrl: '/templates/pages/contracts/contractsList/contractsList.html',
        controller: 'ContractsListController',
        controllerAs: 'vm',
    });